import { ArrowLeft } from "@mui/icons-material";
import { Box, styled, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";

const Caption = styled("p")({
  fontSize: "12px",
  color: COLORS.GRAY,
  display: "flex",
  alignItems: "center",
  gap: "8px",
});
const GlobalMarketProductPriceChartFavoriteCard = ({ favorite }) => {
  const { industry_name, commodity_type_name, commodity_name, transit_name } =
    favorite;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
        {industry_name}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        <Caption>
          {commodity_type_name}
          {commodity_name && <ArrowLeft />}
        </Caption>

        <Caption>
          {commodity_name}
          {transit_name && <ArrowLeft />}
        </Caption>

        <Caption>{transit_name}</Caption>
      </Box>
    </Box>
  );
};

export default GlobalMarketProductPriceChartFavoriteCard;
